// extracted by mini-css-extract-plugin
export default {"screen-row-layout":"ScreenRowLayout_screen-row-layout__0abAN","screen-row-layout-grid":"ScreenRowLayout_screen-row-layout-grid__JJ8sL"};